import { SettingsFormValues } from 'src/Elements/SystemSettings/Battery/types'
import { BatteryModel } from 'src/Libs/batteries'

/**
 * Transforms a given battery settings model into the battery settings form model.
 *
 * The current adjustment value is used as the initial control value to define the enabled state.
 * See wiki for [more information](https://docs.e3dc.com/display/CLOUD/1.1.5.2.2+-+Battery)
 * about the state control.
 * @param model
 */
const fromModelToFormModelTransformer = (model: BatteryModel): SettingsFormValues => {
  const currentAdjustmentValue = model.voltageAdjustment.target
  return {
    voltage: currentAdjustmentValue,
    isAdjustmentEnabled: Boolean(currentAdjustmentValue),
  }
}

export default fromModelToFormModelTransformer
